import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';

import Header from './components/Header';
import ScoreList from './components/ScoreList';
import LearningRoadmap from './components/LearningRoadmap';
import Footer from './components/Footer';

import Spinner from '../../../../../../components/Spinner';

import ScoreData from './components/ScoreList/dummy-data.js';
import LearningRoadmapData from './components/LearningRoadmap/dummy-data.js';

import './StudentReport.scss';

class StudentReport extends Component {
  constructor (props) {
    super(props);

    console.log(this.props.StudentReport);

    this.ScrollToAction = this.ScrollToAction.bind(this);
  }

  ScrollToAction (RefID) {
    return event => {
      const node = ReactDOM.findDOMNode(this.refs[RefID]);

      console.log(node);

      if (node) {
        node.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };
  };

  render () {
    return (
      (this.props.StudentReportData.loading === false)
        ? (() => {
          const User = this.props.StudentReportData.getUserSalesReport.user;

          return (
            <div className='student-report-wrapper'>
              <Helmet>
                <title>Paragon One Report for {User.first_name + ' ' + User.last_name}</title>
              </Helmet>
              <Header student-report-data={this.props.StudentReportData.getUserSalesReport} ref='header' />
              {(this.props.StudentReportData.getUserSalesReport.scores && this.props.StudentReportData.getUserSalesReport.scores.length > 0 &&
                <ScoreList student-report-data={this.props.StudentReportData.getUserSalesReport} ref='how-you-scored' />
              )}
              <LearningRoadmap student-report-data={this.props.StudentReportData.getUserSalesReport} ref='your-learning-roadmap' />
              <div className='student-report-cta' ref='lets-get-started'>
                <div className='container'>
                  <div className='row'>
                    <div className='col'>
                      <h2>Let's get started</h2>
                      <p>Contact us to learn more about improving your skills!</p>
                      <a href='//paragonone.com/book/privatecoaching' className='btn btn-paragon-one'>Book a consultation</a>
                    </div>
                  </div>
                </div>
              </div>
              <Footer navigate={this.ScrollToAction} ref='contact-us' />
            </div>
          );
        })()
        : <div className='student-report-wrapper--loading'><Spinner /></div>
    );
  }
}

export default StudentReport;



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/index.js